<template>
  <div class="reportNav">
    <el-submenu index="4">
      <template slot="title">
        <i class="iconfont icon-guanlibaobiaoon"></i>
        <span>{{ptitle}}</span>
      </template>
      <el-menu-item
        v-for="(item,i) in menuList"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ptitle: '管理报表',
      menuList: [
        {
          index: '4-1',
          title: '对账报表',
          url: '/report/accountReport'
        }
      ]
    }
  },
  created () {
    this.getCurrentIndex(this.$route.path)
  },
  methods: {
    getCurrentIndex (path) {
      if (path.search('report') !== -1) {
        let selectItem = this.menuList.filter(item => item.url === path)
        this.rediret(selectItem[0])
      }
    },
    rediret (item) {
      this.$emit('rediret', item)
    }
  }
}
</script>
<style lang="scss">
.orderNav {
  border-top: 1px solid rgb(33, 42, 50);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/leftnav/reportNav.vue